export const CLEAN_REDUCER = 'CLEAN_REDUCER';
export const FETCH_BRANDINGS = 'FETCH_BRANDINGS';
export const UPDATE_BRANDING = 'UPDATE_BRANDING';
export const DELETE_BRANDING = 'DELETE_BRANDING';
export const SAVE_BRANDINGS = 'SAVE_BRANDINGS';
export const FETCH_BRANDING_COUNT = 'FETCH_BRANDING_COUNT';
